<template>
<div id="general-modal-container" :style="{width:width,height:height}" v-show="isShow">
  <!--top menu container-->
  <div class="top-menu-container">
    <span class="title">{{title}}</span>
    <div class="iconfont icon-close" @click="closeEvent"></div>
  </div>
  <!--dialog content container-->
  <div class="dialog-content-container" :style="{height:`calc(${height} - 94px)`}">
    <span class="dialog-tips">{{tip}}</span>
    <span class="dialog-content">{{content}}</span>
  </div>
  <!--button container-->
  <div class="button-container" v-if="type ==='alert'">
    <span class="sure-button" @click="sureEvent">确定</span>
  </div>
  <div class="button-container" v-else-if="type === 'confirm'">
    <span class="cancel-button" @click="cancelEvent">取消</span>
    <span class="sure-button" @click="sureEvent">确定</span>
  </div>
</div>
</template>

<script>
export default {
  name: 'generalModal',
  props: {
    maskElement: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '300px'
    },
    height: {
      type: String,
      default: '187px'
    },
    theme: {
      type: String,
      default: '#333333'
    },
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'alert'
    },
    success: {
      type: Function,
      default: () => {
        // console.log('点击了确定按钮');
      }
    },
    cancel: {
      type: Function,
      default: () => {
        // console.log('点击了取消按钮');
      }
    },
    close: {
      type: Function,
      default: () => {
        // console.log('点击了关闭按钮');
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    //init View
    initView() {},
    // close modal 
    closeEvent() {
      this.close();
      this.isShow = false;
    },
    // cancel option
    cancelEvent() {
      this.isShow = false
      this.cancel();
    },
    // sure option
    sureEvent() {
      this.isShow = false
      this.success();
    }
  }

}
</script>

<style scoped>
#general-modal-container {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99999;
  top: calc(50% - 93.5px);
  left: calc(50% - 150px);
  background-color: #ffffff;

}

.top-menu-container {
  width: 100%;
  height: 40px;
  background-color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-menu-container .title {
  font-family: FZLTHJW--GB1-0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #fefeff;
  margin: 0 0 0 20px;
}

.top-menu-container .icon-close {
  font-size: 14px;
  color: #fefeff;
  margin: 0 12px 0 0;
  cursor: pointer;
}

.dialog-content-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.dialog-content-container .dialog-tips {
  font-family: FZLTHJW--GB1-0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #333333;
  margin: 12px 0 0 19px;
}

.dialog-content-container .dialog-content {
  font-family: FZLTHJW--GB1-0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #b3b3b3;
  margin: 5px 0 0 19px;
}

/** button container */
.button-container {
  width: 100%;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 30px 0;
}

.button-container span {
  width: 84px;
  height: 24px;
  border-radius: 12px;
  font-family: FZLTHJW--GB1-0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
}

.button-container .cancel-button {
  border: solid 1px #cccccc;
  color: #999999;
  margin: 0 10px 0 0;
}

.button-container .sure-button {
  background-color: #2783f2;
  color: #fff;
  margin: 0 0 0 10px;
}
</style>
